const allMiddles = [];
export default allMiddles;
